export default "__VITE_ASSET__CPku36GU__"